import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ExtraFieldModel } from '../../models/extra-field.model';
import { CommonHttpService } from '../../services/http.service';
import { Response } from '@angular/http';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ExtraFieldValidatonService } from '../../services/extra-field-validaton.service';
import { ValidationManager } from 'ng2-validation-manager';

@Component({
    'selector': 'extra-fields-list',
    'templateUrl': './extra-fields-list.component.html'
})
export class ExtraFieldsListComponent implements OnInit, AfterViewInit {
    public extraFields: Array<ExtraFieldModel> = [];
    public loading = false;
    public validation: ValidationManager;
    public extraFieldsForm: FormGroup;
    @Input() labelKey: string;
    @Input() formSubmitted: EventEmitter<any> = new EventEmitter();
    @Output() valid: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() filled: EventEmitter<Object> = new EventEmitter<Object>();

    constructor(
        protected http: CommonHttpService,
        private formBuilder: FormBuilder,
        private extraFieldValidationService: ExtraFieldValidatonService
    ) {}

    ngOnInit() {
        this.loading = true;
        this.http
            .get(`/ecommerce/entities/${this.labelKey}/extra-fields`)
            .subscribe((res: Response) => {
                for (const extraFieldData of res.json().data) {
                    extraFieldData.extra_fields.forEach((extraField) => {
                        const model = new ExtraFieldModel();
                        model.form_id = extraFieldData.id;
                        model.fill(extraField);
                        this.extraFields.push(model);
                    });
                }

                this.createForm();
                this.extraFieldValidationService.setExtraFields(this.extraFields);
                this.extraFieldValidationService.setForm(this.extraFieldsForm);
                this.validation = this.extraFieldValidationService.buildValidations();

                for (const control in this.extraFieldsForm.controls) {
                    this.extraFieldValidationService.validate(control);
                }
                this.loading = false;
            }, () => {
                this.loading = false;
            });
    }

    ngAfterViewInit(): void {
        if (this.extraFields.length) {
            this.valid.emit(false);
        }
        this.formSubmitted.subscribe(() => {
            this.valid.emit(
                this.extraFieldValidationService.extraFieldsIsValid()
            );

            for (const control in this.extraFieldsForm.controls) {
                this.extraFieldsForm.controls[control].markAsDirty();
            }
        });
    }

    /**
     * Create an extra fields form with FormBuilder
     * */
    public createForm() {
        const group: object = {};

        for (const extraField of this.extraFields) {
            group[extraField.slug] = new FormControl([]);
            group[extraField.slug].extra_field_form_id = extraField.form_id;
            group[extraField.slug].extra_field_id = extraField.id;
        }

        this.extraFieldsForm = this.formBuilder.group(group);
    }

    /**
     * Validate an extra field when changed
     * */
    public onExtraFieldChanged(slug: string): void {
        this.valid.emit(this.extraFieldValidationService.extraFieldsIsValid());
        this.filled.emit(this.buildExtraFieldsData());

        if (!this.extraFieldValidationService.validate(slug)) {
            this.extraFieldsForm.controls[slug].setErrors({});
        }
    }

    /**
     * Build an object to be sent for request
     * */
    private buildExtraFieldsData(): object {
        const extraField = {};
        for (const control in this.extraFieldsForm.controls) {
            const extraFieldControl: any = this.extraFieldsForm.controls[control];
            if (!extraField.hasOwnProperty(extraFieldControl.extra_field_form_id)) {
                extraField[extraFieldControl.extra_field_form_id] = {};
            }
            extraField[extraFieldControl.extra_field_form_id][extraFieldControl.extra_field_id] = extraFieldControl.value;
        }

        return extraField;
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src560599644/src/src/app/shared/components/extra-fields-list/extra-fields-list.component.ts